import Vue from "vue";

Vue.mixin({
  data() {
    return {
      defaultLanguage: "",
    };
  },

  mounted() {
    if (
      this.$application &&
      this.$application.i18n &&
      this.$application.i18n.defaultLocale
    ) {
      this.defaultLanguage = this.$application.i18n.defaultLocale;
    }
  },

  computed: {
    $homepageLink() {
      if (this.$i18n.locale === this.defaultLanguage) {
        return "/";
      } else {
        return `/${this.$i18n.locale}`;
      }
    },
  },

  methods: {
    $redirectToShopWithCategory(categoryTitle) {
      this.$router.push({
        path: this.$t("link.shop"),
        query: {
          category: categoryTitle,
        },
      });
    },

    async $addToCart(productId) {
      if (!productId) return;
      const cart = await this.$cart.addItem(productId);

      if (cart && !cart.errored) {
        this.$toast.success(this.$t("toast.successfullyAdded"));
      } else this.$toast.error(this.$t("toast.error"));
    },

    $formatDate(dateStr, monthFormatNumeric) {
      if (!dateStr) return;
      const locale = this.$i18n.locale;
      const date = new Date(dateStr);
      var region;

      if (locale === "hr") {
        region = "hr-HR";
      } else region = "en-EN";

      const options = {
        year: "numeric",
        month: monthFormatNumeric ? "numeric" : "long",
        day: "numeric",
      };

      return date.toLocaleDateString(region, options);
    },

    $scrollToTop() {
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
      }, 200);
    },
  },
});
